import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  padding: 60px 0 120px;
  display: flex;
  flex-direction: column;
`;

export const MessagesContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 306px;

  @media (max-width: 1400px) {
    padding: 24px 150px;
  }

  @media (max-width: 1024px) {
    padding: 24px 80px;
  }

  @media (max-width: 768px) {
    padding: 24px 20px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
`;

export const MessageWrapper = styled.div`
  margin-bottom: 24px;
`;

export const MetadataRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 8px;
  padding-left: 42px;

  @media (max-width: 480px) {
    padding-left: 36px;
    flex-wrap: wrap;
  }
`;

export const MetadataLabel = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #616161;

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

export const MetadataValue = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #616161;

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;
